import { useTranslation } from "react-i18next";

import { Stack, Typography } from "@mui/material";

import { ResultText } from "../SpousalMaintenance.types";

interface SpousalMaintenanceResultProps {
  result: ResultText;
}

export function SpousalMaintenanceResult({ result }: SpousalMaintenanceResultProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Typography color="error.main" sx={{ fontWeight: 600 }}>
        {result.headline}
      </Typography>
      {result.summary !== null && (
        <Stack spacing={1}>
          <Typography variant="body2" color="error.main">
            {t("spousalMaintenance.summaryIntro")}
          </Typography>
          <Typography variant="body2" color="error.main" sx={{ whiteSpace: "pre-line", fontStyle: "italic" }}>
            {result.summary}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
